import { render } from "./CognitoCallback.vue?vue&type=template&id=4e8343f4"
import script from "./CognitoCallback.vue?vue&type=script&lang=js"
export * from "./CognitoCallback.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-webapp/frontend-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__